<template>
  <span
    class="inline-flex items-center py-0.5 font-medium capitalize rounded-full text-xs px-2.5"
    :class="{
      'bg-gray-100 text-gray-800': status === 'draft',
      'bg-yellow-100 text-yellow-800': status === 'pending',
      'bg-green-100 text-green-800': status === 'accepted',
      'bg-blue-100 text-blue-800': status === 'archived'
    }">
    {{ status }}
  </span>
</template>

<script setup>
defineProps({
  status: {
    type: String,
    required: true,
  },
});
</script>
